import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AvailableUser {
  id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  avatar_url?: string;
}

export const useAvailableUsers = () => {
  return useQuery({
    queryKey: ["available-users"],
    queryFn: async () => {
      console.log("Fetching available users for partner creation...");
      
      // First get all partner user_ids
      const { data: partnerUsers, error: partnerError } = await supabase
        .from('crm_partners')
        .select('user_id')
        .not('user_id', 'is', null);
      
      if (partnerError) {
        console.error("Error fetching partner users:", partnerError);
        throw partnerError;
      }
      
      const partnerUserIds = partnerUsers?.map(p => p.user_id).filter(Boolean) || [];
      console.log("Partner user IDs to exclude:", partnerUserIds);
      
      // Get users who are authenticated but not yet partners
      let query = supabase
        .from('profiles')
        .select('id, user_id, first_name, last_name, email, phone, avatar_url')
        .not('user_id', 'is', null); // Must be authenticated users
      
      // Exclude existing partners if there are any
      if (partnerUserIds.length > 0) {
        query = query.not('user_id', 'in', `(${partnerUserIds.join(',')})`);
      }
      
      const { data, error } = await query.order('first_name', { ascending: true });
      
      if (error) {
        console.error("Error fetching available users:", error);
        throw error;
      }
      
      console.log("Available users found:", data?.length || 0);
      return (data as AvailableUser[]) || [];
    }
  });
};